import React, { Component } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { l, setPalette } from "../functions";
import { connect } from "react-redux";
import { copyBlock } from "../core/redux/actions";
import { Select, TextField } from "./FormElements";

import axios from "axios";
import GKEvent from "../events";
import { ajaxUri } from "../consts/index";
import html2canvas from "html2canvas";

const mapStateToProps = (state) => {
  return {
    blockToCopy: state.rootReducer.blockToCopy || null,
    palettes: state.rootReducer.palettes || null,
  };
};

const screenShot = (id) => {
  return new Promise((resolve, reject) => {
    let screenShot;

    html2canvas(document.querySelector("#" + id), {
      height: 450,
    }).then((canvas) => {
      screenShot = canvas.toDataURL();

      resolve(screenShot);
    });
  });
};

const getDesignedCategories = (datas) => {
  let categories = [];

  for (const tab of datas.tabs) {
    if (tab.id === "designed_blocks") {
      for (const group of tab.groups) {
        categories.push({
          label: group.title.split("_").join(" "),
          value: group.title.split(" ").join("_"),
        });
      }
    }
  }

  return categories;
};

class SaveBlockDialog extends Component {
  constructor(props) {
    super(props);

    this.defaultState = {
      currentBlockCategory: null,
      newCategoryName: "",
      blockName: "",
      savingBlock: false,
    };

    this.state = this.defaultState;
  }

  _saveBlock = () => {
    this.setState({ savingBlock: true });
    let name, categoryName;

    if (
      this.state.currentBlockCategory === "new_category" &&
      this.state.newCategoryName
    )
      categoryName = this.state.newCategoryName.split(" ").join("_");
    else if (this.state.currentBlockCategory)
      categoryName = this.state.currentBlockCategory;

    if (this.state.blockName)
      name = this.state.blockName.split(" ").join("_") + ".json";

    if (name && categoryName && this.props.blockToCopy) {
      screenShot(this.props.blockToCopy.id).then((img) => {
        axios({
          method: "post",
          url: ajaxUri,
          data: {
            request: "saveBlock",
            blockname: name,
            blockcategory: categoryName,
            jsonBlock: this.props.blockToCopy.json || [],
            img: img,
          },
        })
          .then((result) => {
            GKEvent.notification(result.data.status, result.data.message);

            if (result.data.status === "success") {
              this.props.copyBlock(null);
              this.setState(this.defaultState);

              axios({
                method: "post",
                url: ajaxUri,
                data: {
                  request: "listBlocks",
                },
              })
                .then((result) => {
                  const tabs = result.data;
                  setPalette(tabs);
                })
                .catch((error) => {});
            }
          })
          .catch((error) => {
            GKEvent.notification(
              "error",
              l("Error while saving the block. Please try again.")
            );
          });
      });
    }
  };

  render() {
    return (
      <Dialog
        open={this.props.blockToCopy ? true : false}
        onClose={() => {
          this.props.copyBlock(null);
          this.setState(this.defaultState);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{l("Save block")}</DialogTitle>
        {(this.props.error && (
          <div className="gk-error-message inline" style={{ margin: 15 }}>
            <p>{this.props.error}</p>
          </div>
        )) || (
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {l(
                'Choose a category to save your block to. Once saved, you will find it in the "Designed blocks" section.'
              )}
            </DialogContentText>
            <div className="options-container inlined">
              <div>
                <label className="small-label">{l("Select category")}</label>
                <Select
                  value={this.state.currentBlockCategory}
                  onChange={(value) => {
                    this.setState({ currentBlockCategory: value });
                  }}
                  options={[
                    ...[{ label: l("New category"), value: "new_category" }],
                    ...getDesignedCategories(this.props.palettes[0]),
                  ]}
                  size="medium"
                  hardOptions={true}
                />
              </div>
              {this.state.currentBlockCategory === "new_category" && (
                <div>
                  <label className="small-label">{l("Category's name")}</label>
                  <TextField
                    placeholder={l("My new category...")}
                    value={this.state.newCategoryName || ""}
                    onChange={(value) => {
                      this.setState({ newCategoryName: value });
                    }}
                    size="small"
                  />
                </div>
              )}
              {((this.state.currentBlockCategory !== null &&
                this.state.currentBlockCategory !== "new_category") ||
                (this.state.currentBlockCategory === "new_category" &&
                  this.state.newCategoryName)) && (
                <div>
                  <label className="small-label">{l("Block's name")}</label>
                  <TextField
                    placeholder={l("My new block...")}
                    value={this.state.blockName || ""}
                    onChange={(value) => {
                      this.setState({ blockName: value });
                    }}
                    size="small"
                  />
                </div>
              )}
            </div>
          </DialogContent>
        )}
        {!this.props.error && (
          <DialogActions>
            <button
              onClick={() => {
                this.props.copyBlock(null);
                this.setState(this.defaultState);
              }}
            >
              <span>{l("Cancel")}</span>
            </button>
            <button
              onClick={() => {
                this._saveBlock();
              }}
              disabled={
                ((this.state.currentBlockCategory !== null &&
                  this.state.currentBlockCategory !== "new_category") ||
                  (this.state.currentBlockCategory === "new_category" &&
                    this.state.newCategoryName)) &&
                this.state.blockName?.trim() &&
                !this.state.savingBlock
                  ? false
                  : true
              }
            >
              <span>
                {this.state.savingBlock ? l("Saving Block") : l("Save")}
              </span>
            </button>
          </DialogActions>
        )}
      </Dialog>
    );
  }
}

export default connect(mapStateToProps, { copyBlock })(SaveBlockDialog);
